(function (angular) {
    'use strict';

    angular.module('reports')
        .factory('chatAnalyticsService', [
            '$http', "portalConfig", "$q", function ($http, portalConfig, $q) {
                var urlBase = portalConfig.urlBase;

                var fac = {
                    getHistoricData: getHistoricData,
                    getLastHalfHourData: getLastHalfHourData,
                    getLastHourData: getLastHourData,
                    getSampling: getSampling,
                    getLastHalfHourStartTime: getLastHalfHourStartTime
                };

                return fac;

                function getSampling(from, to) {

                    var dFrom = new Date(from);
                    var dTo = new Date(to);
                    var by;
                    var days = (dTo.getTime() - dFrom.getTime()) / (24 * 60 * 60 * 1000);
                    if (days < 3) {
                        by = 'hour';
                    }
                    else if (days < 180 && days >= 3) {
                        by = 'day';
                    }
                    else if (days >= 180 && days < 1095) {
                        by = 'month';
                    }
                    else {
                        by = 'year';
                    }
                    return by;
                }

                function getHistoricData(id, from, to, teamId) {

                    var period = getSampling(from, to);

                    var url = urlBase + "/apispaces/" + id + "/analytics/chats/?from=" + from + "&to=" + to + "&teamId=" + teamId + "&by=agent&by=" + period;
                    return $http.get(url)
                        .then(getHistoricDataComplete)
                        .catch(getHistoricDataFailed);

                    function getHistoricDataComplete(response) {
                        response.data.period = period;
                        return response.data;
                    }

                    function getHistoricDataFailed(error) {
                        console.error(JSON.stringify(error));
                        return $q.reject(error);
                    }
                }


                /**
                 * Provided as method so can be unit tested
                 * @param {*} timestamp 
                 */
                function getLastHourStartTime(timestamp) {
                    var minutesPastHour = timestamp.getMinutes();

                    var from = new Date(timestamp - 1000 * 60 * (minutesPastHour + 60));
                    from.setMinutes(0, 0, 0);
                    return from;
                }

                /**
                 * Provided as method so can be unit tested
                 * @param {*} timestamp 
                 */
                function getLastHalfHourStartTime(timestamp) {
                    var from;

                    var minutesPastHour = timestamp.getMinutes();

                    if (minutesPastHour > 30) {
                        // need to go from on the hour
                        from = new Date(timestamp - 1000 * 60 * minutesPastHour);
                    } else {
                        // need to go from on the hour but minus an hour
                        from = new Date(timestamp - 1000 * 60 * (minutesPastHour + 60));
                    }

                    from.setMinutes(0, 0, 0);

                    return from;
                }


                function _getTimeRangeDate(id, from, to) {
                    var url = urlBase + "/apispaces/" + id + "/analytics/chats?from=" + from.toISOString() + "&to=" + to.toISOString() + "&by=agent&by=team";

                    return $http.get(url)
                        .then(getTimeRangeComplete)
                        .catch(getTimeRangeFailed);

                    function getTimeRangeComplete(response) {
                        return response.data;
                    }

                    function getTimeRangeFailed(error) {
                        console.error(JSON.stringify(error));
                        return $q.reject(error);
                    }
                }


                function getLastHourData(id) {
                    var now = new Date();
                    var from = getLastHourStartTime(now);

                    return _getTimeRangeDate(id, from, now);
                }

                function getLastHalfHourData(id) {
                    var now = new Date();
                    var from = getLastHalfHourStartTime(now);

                    return _getTimeRangeDate(id, from, now);
                }

            }]);

})(window.angular);